// extracted by mini-css-extract-plugin
export default {"modalFooterButtons":"modalFooterButtons---AOs94"};